import script from "./Frente.vue?vue&type=script&setup=true&lang=js"
export * from "./Frente.vue?vue&type=script&setup=true&lang=js"

import "./Frente.vue?vue&type=style&index=0&id=72a9c5fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a9c5fe"]])

export default __exports__